import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import useOnClickOutside from "utils/hooks/useOnClickOutside";
import { StyledModal } from "components/shared";
import { Button } from "components/components/atoms";
import { Copy, Heading } from "components/components/atoms";
import useBreakpoint from "utils/hooks/useBreakpoint";

const StyledHeading = styled(Heading)`
  margin-bottom: 0;
`;
const StyledButton = styled(Button)`
  width: 100%;
`;
const ModalContent = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? `
        width: 91.5vw;
        height: 90vh;
        margin: auto;
      `
      : `
        width: 80vw;
        height: 80vh;
        margin: auto;
        max-width: 69.625rem;
      `}
`;

const ABAModal = (props) => {
  const {
    isOpen = false,
    onClose = () => {},
    title = "",
    text = "",
    subtitle = "",
    copy = "",
    ctaText = "",
    table = {},
    tableMobile = {},
    ctaHref = {},
  } = props;

  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  const modalRef = useRef();
  const ctaRef = useRef();
  useOnClickOutside(modalRef, onClose);

  let imageSrc = "";
  let imageAlt = "";
  if (isMobile) {
    imageSrc = tableMobile.srcMobile || table.src;
    imageAlt = tableMobile.alt;
  } else {
    imageSrc = table.srcDesktop || table.src;
    imageAlt = table.alt;
  }

  return (
    <StyledModal
      isOpen={isOpen}
      className="bg-black-faded-light select-none flex w-full"
      data-aos="fade"
      tabIndex={0}
      id="ABAModalContainer"
    >
      <ModalContent
        isMobile={isMobile}
        className="overflow-auto h-full rounded"
        aria-modal="true"
        role="dialog"
        aria-labelledby="aba_modal_label"
        aria-describedby="aba_modal_desc"
        ref={modalRef}
      >
        <div className="w-full flex flex-col bg-white rounded text-action-blue pt-10 lg:pt-20 px-5 md:px-20 lg:px-32">
          <StyledHeading
            className="pb-5 md:pb-10 pt-1 md:pt-0 tracking-tight text-center"
            id="aba_modal_label"
          >
            {title}
          </StyledHeading>
          <Copy
            className="text-center pt-1 md:pt-0 pb-24 md:pb-5 lg:pb-10 tracking-tight"
            id="aba_modal_desc"
          >
            {text}
          </Copy>
          {imageSrc && (
            <img src={imageSrc} alt={imageAlt} className="mt-1 md:mt-0" />
          )}
          <span className=" font-trade-gothic-20 text-2xl text-mattamy-blue pt-10 tracking-tight text-center">
            {subtitle}
          </span>
          <Copy className="text-center pt-1 md:pt-0 pb-4 tracking-tight">
            {copy}
          </Copy>

          <StyledButton
            className="mb-5"
            onClick={onClose}
            href={ctaHref.href}
            target={ctaHref.target || "_self"}
            linkWrapperDescription={ctaText}
            linkRole="button"
            tabIndex={-1}
            ref={ctaRef}
          >
            {ctaText}
          </StyledButton>
          <StyledButton
            className="mb-10 hover:text-white hover:bg-action-blue"
            color="mattamy-blue"
            variant="outlined"
            onClick={onClose}
            buttonDescription={"Close modal"}
            onKeyDown={(e) => {
              if (!e.shiftKey && e.key === "Tab") {
                e.preventDefault();
                const element = document.getElementById("ABAModalContainer");
                if (element) {
                  element.focus();
                }
              }
            }}
          >
            {"Close"}
          </StyledButton>
        </div>
      </ModalContent>
    </StyledModal>
  );
};

export default ABAModal;
